import { Button, Image } from "antd";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import BackIcon from "../../assets/icons/BackIcon";
import placeholder from "../../assets/images/placeholder.png";

type TitleBarProps = {
  title: string;
  leftChildren?: ReactNode;
  children?: ReactNode;
  backLink?: string;
  subTitle?: string;
  image?: string;
};

export default function TitleBar({
  title,
  subTitle,
  leftChildren,
  children,
  backLink,
  image,
}: TitleBarProps) {
  return (
    <div className="flex justify-between items-center mb-4">
      <div className="flex items-center gap-3.5">
        {backLink && (
          <Link to={backLink}>
            <Button className="button-white-bordered">
              <BackIcon />
              Back
            </Button>
          </Link>
        )}
        {image && (
          <Image
            src={image || placeholder}
            height={56}
            width={56}
            className="rounded-full"
            preview={false}
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src = placeholder;
            }}
          />
        )}
        <div>
          <h4 className="text-theme-gray-900 text-2xl font-medium">{title}</h4>
          <p className="text-theme-gray-700 text-sm">{subTitle}</p>
        </div>
        {leftChildren}
      </div>

      {children}
    </div>
  );
}
